// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2X1M{display:flex;align-items:center;justify-content:center;padding-bottom:2.4rem}._2l1r{list-style:none;display:flex;padding:0}._1Yk7,._3Spg{width:5rem;min-height:2.4rem;color:#000;display:flex;align-items:center;justify-content:center}@media (max-width:35.9375em){._1Yk7,._3Spg{width:3rem}}._1Yk7 svg,._3Spg svg{margin:0}._1Yk7 svg{transform:rotate(-90deg)}._3Spg svg{transform:rotate(90deg)}._2cvt{height:2.4rem;min-width:3rem;margin:0 .5rem;box-shadow:0 4px 8px rgba(0,0,0,.08);cursor:pointer;text-align:center;background-color:#fff}@media (max-width:22.375em){._2cvt{min-width:2.8rem;min-width:2.4rem;margin:0 .3rem}}._2cvt ._1aua{color:#000;display:block}._2cvt._1FQN{background-color:#373737}._2cvt._1FQN ._1aua{color:#fff}._2cvt:hover{background-color:#373737}._2cvt:hover ._1aua{color:#fff}._2cvt:hover svg{fill:#fff}html[dir=rtl] ._1Yk7 svg{transform:rotate(-90deg) rotateX(180deg)}html[dir=rtl] ._3Spg svg{transform:rotate(90deg) rotateX(180deg)}", ""]);
// Exports
exports.locals = {
	"pagination": "_2X1M",
	"paginationList": "_2l1r",
	"next": "_1Yk7",
	"prev": "_3Spg",
	"item": "_2cvt",
	"page": "_1aua",
	"current": "_1FQN"
};
module.exports = exports;
